import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  so_luong?: number;
  chi_phi?: number;
  thue?: number;
  tong_thanh_toan?: number;
  tong_tien?: number;
  chiet_khau?: number;
  state: FormFieldState;
}

export function BottomBar({
  so_luong = 0,
  chi_phi = 0,
  thue = 0,
  tong_thanh_toan = 0,
  tong_tien = 0,
  chiet_khau = 0,
  state
}: BottomBarProps) {
  const ck_yn = state.ck_yn;

  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex min-w-[1180px] items-start gap-6 overflow-x-auto'>
        <div className='flex min-w-[180px] flex-col'>
          <div className='flex items-center gap-2'>
            <Label className='w-28 shrink-0 font-medium'>Tổng số lượng</Label>
            <div className='flex-1'>
              <FormFieldV2 name='t_so_luong' type='text' disabled value={formatRoundedNumber(so_luong, 6)} />
            </div>
          </div>
        </div>

        <div className='flex min-w-[260px] flex-col'>
          <div className='flex items-center gap-2'>
            <Label className='w-24 shrink-0 font-medium'>Tổng chi phí</Label>
            <div className='flex-1'>
              <FormFieldV2
                name='t_cp_nt'
                type='text'
                disabled
                value={formatRoundedNumber(chi_phi)}
                className='text-right'
              />
            </div>
          </div>
          <div className='hidden'>
            <FormFieldV2 name='t_cp' type='text' disabled value={formatRoundedNumber(chi_phi)} />
          </div>
          <div className='flex items-center gap-2'>
            <Label className='w-24 shrink-0 font-medium'>Tổng thuế</Label>
            <div className='flex-1'>
              <FormFieldV2
                name='t_thue_nt'
                type='text'
                disabled
                value={formatRoundedNumber(thue)}
                className='text-right'
              />
            </div>
          </div>
          <div className='hidden'>
            <FormFieldV2 name='t_thue' type='text' disabled value={formatRoundedNumber(thue)} />
          </div>
        </div>

        <div className='flex min-w-[260px] flex-col'>
          {ck_yn && (
            <>
              <div className='flex items-center gap-2'>
                <Label className='w-32 shrink-0 font-medium'>Tổng chiết khấu</Label>
                <div className='flex-1'>
                  <FormFieldV2
                    name='t_ck_nt'
                    type='text'
                    disabled
                    value={formatRoundedNumber(chiet_khau)}
                    className='text-right'
                  />
                </div>
              </div>
              <div className='hidden'>
                <FormFieldV2 name='t_ck' type='text' disabled value={formatRoundedNumber(chiet_khau)} />
              </div>
            </>
          )}
        </div>

        <div className='flex min-w-[280px] flex-col'>
          <div className='flex items-center gap-2'>
            <Label className='w-32 shrink-0 font-medium'>Tổng tiền</Label>
            <div className='flex-1'>
              <FormFieldV2
                name='t_tien_nt'
                type='text'
                disabled
                value={formatRoundedNumber(tong_tien)}
                className='text-right'
              />
            </div>
          </div>
          <div className='hidden'>
            <FormFieldV2 name='t_tien' type='text' disabled value={formatRoundedNumber(tong_tien)} />
          </div>
          <div className='flex items-center gap-2'>
            <Label className='w-32 shrink-0 font-medium'>Tổng thanh toán</Label>
            <div className='flex-1'>
              <FormFieldV2
                name='t_tt_nt'
                type='text'
                disabled
                value={formatRoundedNumber(tong_thanh_toan)}
                className='text-right'
              />
            </div>
          </div>
          <div className='hidden'>
            <FormFieldV2 name='t_tt' type='text' disabled value={formatRoundedNumber(tong_thanh_toan)} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
